import React from "react";
import UserDetail from "../pages/User/UserDetail";

export const ROUTES = {
  LOGIN: "/login",
  FORGOT: "/forgot",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  TRANSACTION: "/transactions",
  USER: "/user",
  USER_DETAIL: "/user/:id",
  RESTRICTED_USER: "/user/restricted-user",
  ADD_RESTRICTED_USER: "/user/add-restricted-user",
  LOCATION: "/location",
  CHARGE_SESSION: "/charge-sessions",
  CHARGE_SESSION_DETAIL: "/charge-sessions/:id",
  PROMO_CODE: "/promo-codes",
  PROMO_CODE_DETAIL: "/promo-codes/:id",
  PROMO_CODE_ADD: "/promo-codes/create",
  PROMO_PROGRAM: "/promo-programs",
  SUBSCRIPTION_PLAN: "/subscription-plans",
  SUBSCRIPTION: "/subscriptions",
  CHARGER_POINT: "/charger-point",
  CHARGER_POINT_DETAIL: "/charger-point/:id",
  CHARGER_POINT_RESTRICTED_USER: "/charger-point/:id/restricted-user",
  IDLING_ACTIVITIES: "/idling-activities",
  CHARGER_POINT_IDLING_PENALTY: "/charger-point/:id/idling-penalty",
  CHARGER_POINT_PRICE: "/charger-point/:id/price",
  CHARGER_POINT_RESERVATION: "/charger-point/:id/reservation",
  MASTER: "",
  NOTFOUND: "*",
  RESERVATION: "/reservation",
  RESERVATION_DETAIL: "/reservation/:id",
  EVSE: "/evse",
  EVSE_DETAIL: "/evse/:id",
  INFORMATION_CATEGORY: "/information-category",
  INFORMATION: "/information",
  REPORTS: "/reports",
  REPORTS_DETAIL: "/reports/:id",
  QUEUING: "/queuing",
  AUDIT_LOG: "/audit-log",
  REWARDS: "/points",
  OTHERS: "/others",
  REWARDS_PROGRAMS: "/rewards-programs",
  REWARDS_TYPES: "/rewards-types",
  REWARDS_CODES: "/rewards-codes",
  BRAND_PARTNERS: "/brand-partners",
  REWARDS_CATEGORIES: "/reward-categories",
  REWARD_BANNERS: "/reward-banners",
} as const;

//  ============  PUPLIC ROUTER  ============

const Register = React.lazy(() => import("../pages/Register"));
const Login = React.lazy(() => import("../pages/Auth/Login"));
const ForgotPassword = React.lazy(() => import("../pages/Auth/Forgot"));

export const publicRoutes: ComponentType[] = [
  { path: ROUTES.LOGIN, component: Login },
  { path: ROUTES.FORGOT, component: ForgotPassword },
  { path: ROUTES.REGISTER, component: Register },
];

//  ============  PRIVATE ROUTER  ============

const ChargeSessions = React.lazy(() => import("../pages/ChargeSessions"));
const Dashboard = React.lazy(() => import("../pages/Dashboard"));
const Location = React.lazy(() => import("../pages/LocationTable"));
const User = React.lazy(() => import("../pages/User"));
const RestrictedUser = React.lazy(() => import("../pages/User/restricted"));
const Transactions = React.lazy(() => import("../pages/Transactions"));
const DetailChargeSessions = React.lazy(
  () => import("../pages/ChargeSessions/Detail")
);
const PromoCodes = React.lazy(() => import("../pages/PromoCode"));
const PromoPrograms = React.lazy(() => import("../pages/PromoProgram"));
const SubscriptionPlans = React.lazy(
  () => import("../pages/SubscriptionPlans")
);
const Subscriptions = React.lazy(() => import("../pages/Subscriptions"));
const ChargerPoint = React.lazy(
  () => import("../pages/ChargerPoint/TableChargerPoint")
);
const Reservation = React.lazy(() => import("../pages/Reservation"));
// const ReservationDetail = React.lazy(() => import("../pages/Reservation"));
const Evse = React.lazy(() => import("../pages/Evse"));
const Information = React.lazy(() => import("../pages/Information"));
const InformationCategories = React.lazy(
  () => import("../pages/InformationCategory")
);

const ChargePointPrice = React.lazy(
  () => import("../pages/ChargerPoint/Price")
);
const ChargerPointRestrictedUser = React.lazy(
  () => import("../pages/ChargerPoint/RestrictedUser")
);
const ChargerPointIdling = React.lazy(
  () => import("../pages/ChargerPoint/IdlingPenalty")
);
const IdlingActivities = React.lazy(
  () => import("../pages/ChargeSessions/IdlingActivities")
);

const Reports = React.lazy(() => import("../pages/Reports"));
const ReportsDetail = React.lazy(() => import("../pages/Reports/Detail"));

const ChargerPointDetail = React.lazy(
  () => import("../pages/ChargerPoint/Detail")
);
const ChargerPointReversation = React.lazy(
  () => import("../pages/ChargerPoint/Reservation")
);

const EvseDetail = React.lazy(() => import("../pages/Evse/Detail"));

//component

const Icon = React.lazy(() => import("../pages/component/Icon"));
const Queuing = React.lazy(() => import("../pages/Queuing"));
const AuditLog = React.lazy(() => import("../pages/AuditLog"));
const Rewards = React.lazy(() => import("../pages/Rewards/"));
const OthersPage = React.lazy(() => import("../pages/Rewards"));
const RewardsPrograms  = React.lazy(() => import("../pages/RewardPrograms"));
const RewardsTypesPage = React.lazy(() => import("../pages/RewardsTypes"));
const RewardsCodesPage = React.lazy(() => import("../pages/RewardsCode"));
const BrandPartnersPage = React.lazy(() => import("../pages/BrandPartners"));
const RewwardCategoriesPage = React.lazy(() => import("../pages/RewardCategories"));
const RewardBannersPage = React.lazy(() => import("../pages/RewardBanners"));



export const PrivateRouter = [
  { path: ROUTES.DASHBOARD, component: Dashboard },
  { path: ROUTES.MASTER, component: Dashboard },
  { path: ROUTES.CHARGE_SESSION, component: ChargeSessions },
  { path: ROUTES.TRANSACTION, component: Transactions },
  { path: ROUTES.LOCATION, component: Location },
  { path: ROUTES.USER, component: User },
  { path: ROUTES.USER_DETAIL, component: UserDetail },
  { path: ROUTES.RESTRICTED_USER, component: RestrictedUser },
  { path: ROUTES.PROMO_PROGRAM, component: PromoPrograms },
  { path: ROUTES.SUBSCRIPTION_PLAN, component: SubscriptionPlans },
  { path: ROUTES.SUBSCRIPTION, component: Subscriptions },
  { path: ROUTES.CHARGE_SESSION_DETAIL, component: DetailChargeSessions },
  { path: ROUTES.PROMO_CODE, component: PromoCodes },
  { path: ROUTES.CHARGER_POINT, component: ChargerPoint },
  { path: ROUTES.CHARGER_POINT_DETAIL, component: ChargerPointDetail },
  {
    path: ROUTES.CHARGER_POINT_RESTRICTED_USER,
    component: ChargerPointRestrictedUser,
  },
  { path: ROUTES.RESERVATION, component: Reservation },
  { path: ROUTES.EVSE, component: Evse },
  { path: ROUTES.EVSE_DETAIL, component: EvseDetail },
  { path: ROUTES.QUEUING, component: Queuing },
  { path: ROUTES.INFORMATION_CATEGORY, component: InformationCategories },
  { path: ROUTES.INFORMATION, component: Information },
  { path: ROUTES.CHARGER_POINT_PRICE, component: ChargePointPrice },
  { path: ROUTES.CHARGER_POINT_IDLING_PENALTY, component: ChargerPointIdling },
  { path: ROUTES.IDLING_ACTIVITIES, component: IdlingActivities },
  { path: ROUTES.REPORTS, component: Reports },
  { path: ROUTES.REPORTS_DETAIL, component: ReportsDetail },
  {
    path: ROUTES.CHARGER_POINT_RESERVATION,
    component: ChargerPointReversation,
  },
  { path: "/component/icon", component: Icon },
  { path: ROUTES.AUDIT_LOG, component: AuditLog },
  { path: ROUTES.REWARDS, component: Rewards },
  { path: ROUTES.OTHERS, component: OthersPage },
  { path: ROUTES.REWARDS_PROGRAMS, component: RewardsPrograms },
  { path: ROUTES.REWARDS_TYPES, component: RewardsTypesPage },
  { path: ROUTES.REWARDS_CODES, component: RewardsCodesPage },
  { path: ROUTES.BRAND_PARTNERS, component: BrandPartnersPage },
  { path: ROUTES.REWARDS_CATEGORIES, component: RewwardCategoriesPage },
  { path: ROUTES.REWARD_BANNERS, component: RewardBannersPage },
];
